import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export function formatApiError(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Något gick fel. Försök igen.";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d
      .map((x) => (x && typeof x.msg === "string" ? x.msg : ""))
      .filter(Boolean)
      .join(" ");
  if (d && typeof d.msg === "string") return d.msg;
  return String(d);
}
